import { Amount } from './global';

export type DeliveryGeometry = import('geojson').Polygon;
export type MultiPolygonType = import('geojson').MultiPolygon;
export type ComputedGeometry =
  | import('geojson').Polygon
  | import('geojson').MultiPolygon;

interface FlatDeliveryFee {
  type: 'flat';
  amount: Amount;
}

interface ThresholdMinimumOrderValue {
  type: 'threshold_difference';
  threshold: Amount;
}

type FlatDeliveryFeeError = {
  type?: string;
  amount: { [k in keyof Amount]?: string };
};

type ThresholdMinimumOrderValueError = {
  type?: string;
  threshold: { [k in keyof Amount]?: string };
};

export type DeliveryFee = FlatDeliveryFee;
export type DeliveryFeeError = FlatDeliveryFeeError;
export type MinimumOrderValue = ThresholdMinimumOrderValue;
export type MinimumOrderValueError = ThresholdMinimumOrderValueError;

export type DistanceInterval = {
  maximumDistance: number;
  deliveryFee: Partial<DeliveryFee>;
  minimumOrderValue: Partial<MinimumOrderValue>;
};

export interface DeliveryArea {
  id: string;
  name?: string;
  blueprintId?: string;
  geometry?: DeliveryGeometry;
  deliveryFee?: DeliveryFee;
  minimumOrderValue?: MinimumOrderValue;
  isNew?: boolean;
  distanceIntervals?: DistanceInterval[];
}

export interface DeliveryAreasSettings {
  radiusKmMax: number;
  deliveryFeeFractionalMax: number;
  minimumOrderValueFractionalMax: number | null;
}

export interface DeliveryAreasSettingsError {
  status?: number;
  error?: string;
}

export interface DeliveryAreaError {
  message?: string;
  errors?: {
    name?: string;
    geometry?: string;
    deliveryFee?: DeliveryFeeError;
    minimumOrderValue?: MinimumOrderValueError;
  };
}

export interface BlueprintArea {
  id: string;
  name: string;
  geometry: ComputedGeometry;
}

export interface BlueprintAreaError {
  message?: string;
  errors?: {
    name?: string;
    geometry?: string;
  };
}

export interface DeliveryRadius {
  km: number;
}

export enum EditMode {
  Radius = 'radius',
  Postcode = 'postcode',
}
